import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Content Side */}
            <div className="p-12 lg:p-16 flex flex-col justify-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Ready to Experience True Custom Tailoring?
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Call for appointment today and discover why discerning gentlemen throughout Massachusetts trust Custom Clothiers for their tailoring needs.
              </p>

              {/* Benefits List */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="ml-4 text-gray-300">Free consultation and style guidance</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="ml-4 text-gray-300">30+ precise measurements for perfect fit</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="ml-4 text-gray-300">5000+ fabrics available for suits</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-[#C4A962] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="ml-4 text-gray-300">We make house and office calls</span>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="bg-[#C4A962] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 text-center whitespace-nowrap"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Call for Appointment
                </Link>
                <a
                  href="tel:781-237-3166"
                  className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 text-center whitespace-nowrap"
                >
                  <i className="ri-phone-line mr-2"></i>
                  781-237-3166
                </a>
              </div>
            </div>

            {/* Image Side */}
            <div className="relative h-64 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/5517cd207302ed91745a6544ca4d835b.jpg"
                alt="Custom tailored suit"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-gray-900/50 to-transparent lg:from-gray-900 lg:to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;